export const LANDING_PAGE_URLS = {
    PRODUCTION: 'https://knowbetterplanbetter.com/landing-page/',
    PREVIEW: 'https://kbpb-sandbox.taboola-content-affiliation.com/landing-page?preview=true&page=',
};
